module.exports = __webpack_public_path__ + "img/bg-cant-find@2x.409f7e41.jpeg";